import { AppDispatcher } from '@wsb/guac-widget-shared/lib/common/ols-core/shared-bundle';
import { OlsConfigStore } from '@wsb/guac-widget-shared/lib/common/ols-core/core-bundle';
import PreloadResourceStore from './PreloadResourceStore';

const { dispatchServerAction } = AppDispatcher;

function preloadHelper(resources, type) {
  if (!resources || !resources.length) {
    return;
  }

  for (const resource of resources) {
    const { url, id } = resource;
    if (!url) continue;

    if (type === 'css') {
      loadCSSResource(url, id);
    } else if (type === 'js') {
      loadJSResource(url, id);
    }
  }
}

function loadCSSResource(url, id) {
  var element = document.createElement('link');
  element.id = `preload-css-${id}`;
  element.rel = 'preload';
  element.as = 'style';
  element.href = url;
  document.head.appendChild(element);
}

function loadJSResource(url, id) {
  var element = document.createElement('link');
  element.id = `preload-js-${id}`;
  element.rel = 'preload';
  element.as = 'script';
  element.href = url;
  document.head.appendChild(element);
}

export function preloadResources() {
  const { resourcesToPreload } = OlsConfigStore.getState();
  const { resourcesPreloaded } = PreloadResourceStore.getState();
  const { css, js } = resourcesToPreload;
  if (resourcesPreloaded || (!css && !js)) {
    return;
  }

  preloadHelper(css, 'css');
  preloadHelper(js, 'js');

  setTimeout(() => {
    dispatchServerAction({
      type: 'RESOURCES_PRELOADED'
    });
  }, 0);
}

export default { preloadResources };
